export interface ValidationError {
  field: string;
  message: string;
}

export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validatePhone(phone: string): boolean {
  return /^[\d+\-()\s]{7,}$/.test(phone);
}

export function validateWhatsapp(whatsapp: string): boolean {
  return /^\+?\d{7,}$/.test(whatsapp.replace(/\s/g, ''));
}

export function validateHexColor(color: string): boolean {
  return /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/.test(color);
}

export function validateUrl(url: string): boolean {
  if (!url) return true;
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

export function validateSubdomain(subdomain: string): boolean {
  return /^[a-z0-9-]{1,63}$/.test(subdomain);
}

export function validateProjectName(name: string): boolean {
  return /^[a-z0-9-]+$/.test(name);
}

export function formatWhatsappLink(number: string, message?: string): string {
  const cleaned = number.replace(/\D/g, '');
  const base = `https://wa.me/${cleaned}`;
  if (message) {
    return `${base}?text=${encodeURIComponent(message)}`;
  }
  return base;
}
